import Vue from 'vue'

const components = {
  ArrowDirection: () => import('@/components/modal/subviews/ArrowDirection'),
  LightFeedback: () => import('@/components/modal/subviews/LightFeedback'),
  Generic: () => import('@/components/modal/subviews/Generic')
}
Object.entries(components).forEach(([name, component]) => Vue.component(name, component))
